import angular from 'angular';
import assetInsuranceDetails from './assetInsuranceDetails';

export default angular
  .module('components.assetInsuranceDetails', [])
  .component('assetInsuranceDetails', assetInsuranceDetails).name;
